//react...
import React from "react";
import afterSalesImage from "../../assets/afterSales/afterSales_01.jpeg";
//recat-bootstrap
import { Container, Card, Row, Col } from "react-bootstrap";

const AfterSalesServicePage = () => {
  return (
    <Container>
      <Card border="danger" className="mt-3">
        <Card.Header>About Us</Card.Header>
        <Row>
          <Col lg={6}>
            <Card.Body>
              <Card.Text as="span">
                <p className="about-typo">
                  &#9726; By having an equipped After Sale Service Premises
                  Armco Trading Company owes a 1000 m2 property containing
                  Workshop (550 m2), Warehouse (200 m2), Office (140 m2) and
                  outdoor enclosure (160 m2).
                </p>
                <p className="about-typo">
                  &#9726; Such a premises gained all needed licenses and
                  standard certificate for after sale services.
                </p>

                <p className="about-typo">
                  &#9726; Also, a first-class team of experienced technicians
                  have been recruited and are doing excellent work.
                </p>
              </Card.Text>
            </Card.Body>
          </Col>
          <Col lg={6}>
            <Card.Img
              variant="end"
              src={afterSalesImage}
              className="about-image"
            />
          </Col>
        </Row>
      </Card>
    </Container>
  );
};

export default AfterSalesServicePage;
